import "./partials/jquery-global";
import "./partials/off-canvas";
import "./partials/hoverable-collapse";
import "./partials/misc";
import "./partials/settings";
import "./partials/todolist";
import "./partials/data-table";
//import "./partials/dashboard";
import "./partials/chart";
import "./partials/select2";
import "./partials/tinymce";

export default {
  init() {

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/admin/common.js